module.exports = __webpack_public_path__ + "img/300.2be5ca48.png";